import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

// // 오픈시 메인연결
// import Main from "../pages/client/Main.vue";
import Main from "../pages/client/_Main.vue";
// import Main from "../pages/client/Teaser.vue";

import { BoardRoutes } from "./board.router";
import { QuestionRoutes } from "./question.router";
import { ApplicationRoutes } from "./service-application.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        path: "/seoul",
        component: () => import("../pages/client/gate/GatePage.vue"),
        props: true,
    },
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        path: "/common/kcp/cert/request",
        component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
        props: true,
    },
    {
        path: "/common/kcp/cert/response",
        component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
        props: true,
    },
    {
        // 로그인
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
        props: true,
    },
    {
        // 비밀번호 찾기
        path: "/login/find-password",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
        props: true,
    },
    {
        // 아이디 찾기
        path: "/login/find-id",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
        props: true,
    },
    {
        // 회원가입
        path: "/join",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
        props: true,
    },
    {
        // 회원가입 폼
        path: "/join/type",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
        props: true,
    },
    {
        // 회원가입 폼
        path: "/join/form",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
        props: true,
    },
    {
        // 회원가입 완료
        path: "/join/complete",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
        props: true,
    },
    {
        // 회원 정보 변경
        path: "/mypage/myinfo",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
        props: true,
    },
    {
        // 회원 탈퇴
        path: "/mypage/leave",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
        props: true,
    },
    {
        // 1:1 문의
        path: "/mypage/question",
        component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
        children: [...QuestionRoutes],
        props: true,
    },

    {
        // 센터소개-센터개요
        path: "/about",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/about/AboutPage.vue"),
        props: true,
    },
    {
        // 센터소개-장비소개
        path: "/about/equipments",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/about/EquipmentsPage.vue"),
        props: true,
    },
    {
        // 센터소개-오시는길
        path: "/about/location",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/about/LocationPage.vue"),
        props: true,
    },

    {
        // 시설/장비예약 - 예약절차안내
        path: "/rental/intro",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/rental/RentalIntroPage.vue"),
        props: true,
    },
    {
        // 시설/장비예약 - 목록
        path: "/rental/:type",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/rental/RentalSubjectList.vue"),
        props: true,
    },
    {
        // 시설/장비예약 - 예약
        path: "/rental/:type/:_subject",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/rental/RentalSchedulePage.vue"),
        props: true,
    },
    {
        // 마이페이지 - 프로그램
        path: "/mypage/rental-schedules",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/RentalScheduleList.vue"),
        props: true,
    },
    {
        // 마이페이지 - 프로그램
        path: "/mypage/rental-requests",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/RentalRequestList.vue"),
        props: true,
    },
    {
        // 마이페이지 - 프로그램
        path: "/mypage/mes-materials",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/MesMaterialsPage.vue"),
        props: true,
    },
    {
        // 마이페이지 - 프로그램
        path: "/mypage/mes-dashboard",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/MesDashboardPage.vue"),
        props: true,
    },

    {
        // 지원서비스-안내
        path: "/service/about",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceAboutPage.vue"),
        props: true,
    },
    {
        // 지원서비스-목록
        path: "/service/supports",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceSupportList.vue"),
        props: true,
    },
    {
        // 지원서비스-목록
        path: "/service/supports/:category",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceSupportList.vue"),
        props: true,
    },
    {
        // 지원서비스-상세
        path: "/service/supports/:category/:_program",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceSupportView.vue"),
        props: true,
    },
    {
        // 지원서비스-신청 양식
        path: "/service/supports/:category/:_program/apply",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceSupportInput.vue"),
        props: true,
    },
    {
        // 지원서비스-신청 완료
        path: "/service/supports/:category/:_program/complete",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceSupportComplete.vue"),
        props: true,
    },

    {
        // 프로그램 - 목록
        path: "/service/programs",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/service/ServiceProgramList.vue"),
        props: true,
    },
    {
        // 프로그램 - 목록
        path: "/service/programs/:_program",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/service/ServiceProgramView.vue"),
        props: true,
    },
    {
        // 프로그램 - 신청 양식
        path: "/service/programs/:_program/apply",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceProgramInput.vue"),
        props: true,
    },
    {
        // 프로그램 - 신청 완료
        path: "/service/programs/:_program/complete",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/service/ServiceProgramComplete.vue"),
        props: true,
    },

    {
        // 마이페이지 - 지원서비스 목록
        path: "/mypage/applications",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ApplicationPage.vue"),
        children: [...ApplicationRoutes],
        props: true,
    },
    {
        // 마이페이지 - 프로그램 - 목록
        path: "/mypage/program-applications",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ProgramApplicationList.vue"),
        props: true,
    },
    {
        // 마이페이지 - 프로그램 - 상세 (출석확인)
        path: "/mypage/programs/:_program",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ProgramView.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/community/notice",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/community/NoticePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/community/notice/:_notification",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/community/NoticePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-자료실
        path: "/community/reference",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/community/ReferencePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-자료실
        path: "/community/reference/:_reference",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/community/ReferencePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-QnA
        path: "/community/qna",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/community/QnaPage.vue"),
        props: true,
    },
    // {
    //     // 매칭상담회 - 리스트
    //     path: "/fairs",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsListPage.vue"),
    //     props: true,
    // },
    // {
    //     // 매칭상담회 - 뷰
    //     path: "/fairs/:_fair",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsViewPage.vue"),
    //     props: true,
    // },
    // {
    //     // 매칭상담회 - 뷰
    //     path: "/fairs/view",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/fairs/FairsViewPage.vue"),
    //     props: true,
    // },
    {
        // 작가소개
        path: "/board/author-intro",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/AuthorIntro.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 전시 및 행사
        path: "/board/travel",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Travel.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 이벤트
        path: "/board/event",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Event.vue"),
        children: [...BoardRoutes],
        props: true,
    },
    {
        // 문의 및 제휴
        path: "/form/inquiry-partner",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 자주묻는질문
        path: "/center/faqs",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 개인정보처리방침
        path: "/privacy-policy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/PrivacyPolicyPage.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("accessToken") ? `Bearer ${sessionStorage.getItem("accessToken")}` : "";
    axios.defaults.headers.common["Accept-Language"] = i18n.locale;

    next();
});

export default router;
